import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import CustomerStockEntry from './shared/CustomerStockEntry';
import CustomerDetailsCard from './shared/CustomerDetailsCard';
import { useState } from 'react';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const SpecificBulkStock = () => {
  const [apiCall, setApiCall] = useState(false);

  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <CustomerDetailsCard apiCall={apiCall} />
            <CustomerStockEntry apiCall={apiCall} setApiCall={setApiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default SpecificBulkStock;
